// ============================================================================
// НАЗВАНИЕ И ОПИСАНИЕ МОДУЛЯ — ИЗ ПЕРЕВОДОВ, И ТОЛЬКО ОТТУДА.
// ----------------------------------------------------------------------------
// До 1 сентября они лежали ДВАЖДЫ: полями `title`/`summary` в реестре модулей —
// для админки, здоровья и каталога цен, — и в `messages/<локаль>/modules.json` для
// клиента. Два текста об одном товаре, между которыми ничто не держало
// соответствия: правка в одном месте молча расходилась с другим.
//
// Хуже того, вторая половина была неполной: у `transport`, `tenders` и
// `reputation` перевода не было ни на одном из четырёх языков, и клиент на
// шаге «Дополнения» видел `modules.transport.title`. Заметили это по
// туториалу, снятому менеджером.
//
// Теперь источник один — файлы переводов. Реестр знает только ключи.
//
// ── ПОЧЕМУ JSON НАПРЯМУЮ, А НЕ useTranslations ─────────────────────────────
// Этих текстов просят места БЕЗ языкового контекста: серверные действия
// админки, страница здоровья, каталог строк для счёта. Тянуть туда контекст
// запроса ради двух строк значило бы усложнить их все.
//
// Импортируем только `modules.json` каждого языка, а не весь словарь: файл
// маленький, и в сборку не поедет ничего лишнего.
//
// ── ЧТО ГАРАНТИРУЕТ НАЛИЧИЕ КЛЮЧА ──────────────────────────────────────────
// `scripts/check-i18n-registry.py`: он выводит нужные пути ИЗ реестра и валит
// ворота, если для какого-то модуля перевода нет хоть в одном языке. Поэтому
// здесь нет запасного текста — он маскировал бы ровно то, что мы чиним.
// ============================================================================

import ru from '@/messages/ru/modules.json'
import ro from '@/messages/ro/modules.json'
import en from '@/messages/en/modules.json'
import uk from '@/messages/uk/modules.json'

type Texts = Record<string, { title?: string; summary?: string }>

const BY_LOCALE: Record<string, Texts> = {
  ru: ru as Texts, ro: ro as Texts, en: en as Texts, uk: uk as Texts,
}

/** Язык по умолчанию для мест без языкового контекста: админка русская. */
export const MODULE_TEXT_FALLBACK_LOCALE = 'ru'

/**
 * Название модуля. `key` — ключ из реестра (`ModuleKey`).
 *
 * Неизвестный язык — берём русский. Неизвестный ключ — возвращаем сам ключ:
 * это видно глазом и чинится воротами, а выдумывать текст здесь нельзя.
 */
export function moduleTitle(key: string, locale: string = MODULE_TEXT_FALLBACK_LOCALE): string {
  const t = BY_LOCALE[locale] ?? BY_LOCALE[MODULE_TEXT_FALLBACK_LOCALE]
  return t[key]?.title ?? key
}

/** Описание модуля одной фразой — за что клиент платит. */
export function moduleSummary(key: string, locale: string = MODULE_TEXT_FALLBACK_LOCALE): string {
  const t = BY_LOCALE[locale] ?? BY_LOCALE[MODULE_TEXT_FALLBACK_LOCALE]
  return t[key]?.summary ?? ''
}
